import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MonthlyTargetLeadsComponent } from './monthly-target-leads.component';

const routes: Routes = [
  { path: '', component: MonthlyTargetLeadsComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MonthlyTargetLeadsRoutingModule { }
